/**
 * A implementação dos serializadores foi baseada em:
 * http://mcculloughwebservices.com/2016/09/23/handling-a-null-response-from-an-api/
 *
 * Não é possível simplesmente realizar a chamada de response.json()
 * pois decidimos que a nossa API poderia retornar valores com o Body
 * vazio e/ou nulo, sendo assim, ocorreria um erro ao deserializar
 * que é resolvido com a implementação adotada
 */
import serverURL from './serverURL'
import fetchConfig from './fetchConfig'
import STATUS_CODE from './statusCode'
import store from '../createStore'
import * as actions from 'actions/index'

function throwValidationErrors(response) {
  return response.json().then(errors => {
    throw errors
  })
}

function throwUnexpectedError(response, errorMessage) {
  console.log("throwUnexpectedError: ", response)
  console.log("errorMessage: ", errorMessage)
  let error = new Error(errorMessage)
  error.response = response
  throw error
}

function _parseJSON(response) {
  return response.text().then(function (text) {
    return !!text ? JSON.parse(text) : {}
  })
}

// function _parseImagem(response) {
  
//   let data;
//   const urlCreator = window.URL || window.webkitURL;
//   return response.blob().then(blobResponse => {
//     data = blobResponse;
//     return urlCreator.createObjectURL(data);
//   })
// }

export default (path, config, headers, autoHandle = true, autoControlSpinner = true) => {

  if (!!autoControlSpinner) {
    store.dispatch(actions.startRequest())
  }
  return fetch(serverURL.api(path), fetchConfig(config, headers)).then(
    response => {
      if (!!autoControlSpinner) {
        store.dispatch(actions.finishRequest())
      }
      if (response.ok) {
        // var res = response.url.startsWith("http://api-staging.lunch.team/menu/v1/image/restaurant/cover") ||
        //   response.url.startsWith("https://api.lunch.team/menu/v1/image/restaurant/cover") ?
        //   _parseImagem(response) : _parseJSON(response);

        var res =_parseJSON(response);

        return res;
      } else if (STATUS_CODE.isAuthenticationError(response)) {
        store.dispatch(actions.logoutSuccess())
        // - enviar para a rota de login com mensagem
        // avisando que session expirou
        // - excluir informações localStorage
        throwUnexpectedError(response, 'Authentication Error')
        console.error('Authentication Error')
      } else if (!autoHandle) {
        return response
      } else if (STATUS_CODE.isValidationError(response)) {
        // tratar genericamente
        // lançar erro
        return throwValidationErrors(response)
      } else {
        // exibir erro
        // lançar erro
        throwUnexpectedError(response, 'We get some error from our services, please contact the support. Try again later.',
        )
      }
    }
    , error => {
      store.dispatch(actions.finishRequest())
      throwUnexpectedError(error, 'We get some error from our services, please contact the support. Try again later.');
    }
  )
}



// WEBPACK FOOTER //
// ./src/config/fetch/fetch.js